/** Strip any tags from a string */
export const stripTags = (text: string) => {
	// regex from: https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/
	const regex = /(<([^>]+)>)/gi;
	return text.replace(regex, '');
};
